import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getHRPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/odvetvi/hr",
		[Locale.en]: "/industries/hr",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
